/* SS06258: in the device preview, a PDF document open on one device follows the device switch. The
   device showing it reports it on its entry's route as ?documentid=<document id>; the other device
   opens that document from the entry's own documents once the entry has loaded. Only a single entry's
   PDF without an input form is synced - the inputs of one can't travel in a link. Preview only: the
   parameter is neither written nor read outside builder mode. Not "d" (document links) and not a
   "t.." key, which FTSListView reads as a create-form prefill. */

export const DOCUMENT_ID_PARAM = "documentid";

export const isSyncedDocument = (document) =>
  Boolean(document) && document.typeId === "pdf" && !document.hasForm;

/** The query to report while `payload`'s document (a showPDFDocument payload) is open over the entry
    on the route, or null when there is nothing (more) to report. */
export const queryWithOpenDocument = (query, payload, entryIdOf) => {
  if (!query || !query.id || !payload || payload.inputs) return null;
  if (!isSyncedDocument(payload.document)) return null;
  if (!Array.isArray(payload.items) || payload.items.length !== 1) return null;
  if (String(entryIdOf(query.id)) !== String(payload.items[0].id)) return null;

  const documentId = String(payload.document.id);
  if (query[DOCUMENT_ID_PARAM] === documentId) return null;
  return { ...query, [DOCUMENT_ID_PARAM]: documentId };
};

/** The query without the closed document, or null when it names none. */
export const queryWithoutDocument = (query) => {
  if (!query || !query[DOCUMENT_ID_PARAM]) return null;
  const { [DOCUMENT_ID_PARAM]: closed, ...rest } = query;
  return rest;
};

/** The document of `pending` ({ documentId, entryId }) to open in a quick view that has loaded that
    entry's view form, or null while it can't (yet). */
export const previewDocumentToOpen = (pending, { show, loading, entry, header, footer } = {}) => {
  if (!pending || !show || loading || entry !== "view") return null;
  if (!header || String(header.id) !== String(pending.entryId)) return null;
  const documents = (footer && footer.documents) || [];
  return documents.find((x) => x && String(x.id) === String(pending.documentId) && isSyncedDocument(x)) || null;
};
